import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { deepmerge, getProp } from '../libs/utils'
import UserRoles from '../configs/user-roles.json'

Vue.use(Vuex)

export const defaultState = {
  user: null,
  accessToken: null,
  apiToken: null,
  datatable: {},
  balances: {
    windowSize: 5
  },
  version: 1
}

const state = deepmerge(defaultState)

const mutations = {
  RESET_STATE (state) {
    const { user, accessToken, apiToken, ...others } = state // eslint-disable-line no-unused-vars
    mutations.SET_STATE(state, deepmerge(defaultState, others))
  },
  SET_STATE (state, payload = {}) {
    const newState = deepmerge(state, payload)
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_USER (state, payload = {}) {
    state.user = deepmerge(state.user, payload)
  },
  SET_DATATABLE (state, payload = {}) {
    state.datatable = deepmerge(state.datatable, payload)
  },
  SET_BALANCES (state, payload = {}) {
    state.balances = deepmerge(state.balances, payload)
  },
  SET_VERSION (state, payload = 0) {
    state.version = payload
  }
}

const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE')
  },
  setState ({ commit }, payload) {
    commit('SET_STATE', payload)
  },
  setUser ({ commit }, payload) {
    commit('SET_USER', payload)
  },
  setDatatable ({ commit }, payload) {
    commit('SET_DATATABLE', payload)
  },
  setBalances ({ commit }, payload) {
    commit('SET_BALANCES', payload)
  },
  setVersionToLatest ({ commit }) {
    commit('SET_VERSION', defaultState.version)
  }
}

const getters = {
  user (state) {
    return state.user
  },
  role (state) {
    if (!state.user) return null
    const roleName = getProp(state.user, 'role', UserRoles['GUEST'].name)
    return UserRoles[roleName]
  },
  datatable (state) {
    return state.datatable
  },
  balances (state) {
    return state.balances
  },
  isOldVersion (state) {
    return state.version < defaultState.version
  }
}

export const store = new Vuex.Store({
  modules: {
    user: {
      namespaced: true,
      state,
      getters,
      mutations,
      actions
    }
  },
  plugins: [createPersistedState({
    key: 'yellow-dashboard',
    paths: ['user']
  })]
})
